<script setup lang="ts">
import { PromotionProps } from "./Promotion.props"
import { getImageData } from "~/utils/wrapperImage"
import { WrapperImageProps } from "~/components/Utils/WrapperImage.props"
import { SmallProps } from "~/components/ProductBlocks/BrandBlock/Small.props"
import { mapProducts } from "~/utils/mapProducts"

const props = defineProps<PromotionProps>()

const { $cl } = useNuxtApp()

const { data: brandBannerProductsWithPrices } = await useLazyAsyncData(
  "brandBannerProductsWithPrices",
  () => productsPrice($cl, props.brandBanners?.map((b) => b.card) ?? [])
)

const mappedProduct = computed(() =>
  mapProducts(brandBannerProductsWithPrices.value, null, "CONTENTFUL")
)

const groups = computed(() => {
  const groupOfCards = _chunk(props.allPromotionsBrand, 6)

  const groupWithBanner = groupOfCards.map((cards, i) => {
    const banner = props.brandBanners?.[i]

    const card = mappedProduct.value?.find(
      (card) => banner?.card?.productCode === card.productCode
    )

    const bannerWithPrice = banner ? { ...banner, card } : undefined

    return {
      cardPromotion: { cards: cards },
      banner: cards.length === 6 ? bannerWithPrice : undefined
    }
  })
  return groupWithBanner
})

const bgImage: WrapperImageProps = getImageData({
  altText: "background",
  url: "/i5oh5hzamkwo/5GJBkllqz6zJjxT6vBIUmS/0f5c5bce7d463ddbec5988584390f134/cover-banner-wiki-magazine.svg",
  width: 1024,
  height: 220,
  preload: true,
  imgAttrs: { fetchpriority: "high" }
})
</script>

<template>
  <div class="wrapper_promotion-page grid-standard overflow-hidden">
    <BannerWikiMagazine
      :bg-image="bgImage"
      v-bind="wikiMagazine"
      class="negative-margined col-span-full aspect-[4/1]"
    />

    <BannerPromoSpecial
      v-if="promoBanner"
      v-bind="promoBanner"
      class="negative-margined col-span-full"
    />

    <CardPromoOrganismCardPromotion
      v-if="lastPromotions"
      :title="$t('pages.promotion.promoCards.lastNews')"
      :cards="lastPromotions"
      class="col-span-full mt-4 overflow-hidden md:mt-10"
    />

    <p class="dolphin-bold md:elephant-bold col-span-full md:mt-10">
      {{ $t("pages.promotion.promoCards.allPromotion") }}
    </p>

    <template v-for="({ cardPromotion, banner }, i) in groups" :key="i">
      <CardPromoOrganismCardPromotion
        v-if="cardPromotion"
        :cards="cardPromotion.cards"
        class="col-span-full overflow-hidden md:my-4"
        :first-bg-grey="false"
      />

      <ProductBlocksBrandBlockSmall
        v-if="banner"
        v-bind="(banner as SmallProps)"
        class="negative-margined padded col-span-full"
      />
    </template>
    <BannerNewsletter class="col-span-full" />
  </div>
</template>
